import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ImageCarousel from "../components/ImageCarousel";

function ProductPage() {
  const [product, setProduct] = useState(null);
  const productId = useParams().id;
  const whatsappNumber = "14034024516";

  useEffect(() => {
    async function fetchProduct() {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/products/${productId}`,
      );
      const product = await response.json();
      setProduct(product);
    }
    fetchProduct();
  }, [productId]);

  if (!product) return <p>Loading...</p>;
  const siteUrl = "https://shayapparel.store";
  const message = encodeURIComponent(
    `Hi, I'm interested in this item: ${siteUrl}/product/${productId}`,
  );
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${message}`;

  return (
    <div className="product-page">
      <div className="product-images">
        {product.images && product.images.length > 0 ? (
          <ImageCarousel images={product.images} productName={product.name} />
        ) : (
          <div className="carousel-placeholder"></div>
        )}
      </div>
      <div className="product-details">
        <h1>{product.name}</h1>
        <p className="price">${product.price.toFixed(2)}</p>
        {product.sizes && <p className="meta">Sizes: {product.sizes}</p>}
        {product.colors && <p className="meta">Colors: {product.colors}</p>}
        <p className={product.inStock ? "in-stock" : "out-of-stock"}>
          {product.inStock ? "In Stock" : "Out of Stock"}
        </p>
        <a
          href={whatsappLink}
          target="_blank"
          rel="noreferrer"
          className="whatsapp-btn"
        >
          Enquire on WhatsApp
        </a>
      </div>
    </div>
  );
}

export default ProductPage;
